import {
  apiClient,
  type SiteImportJobExEntity,
  type CreateSiteImportJobDto
} from '@/libs/api'

export type CreateSiteImportJobRequest = {
  tenantKey: string
  dto: CreateSiteImportJobDto
}

export const createSiteImportJob = async ({
  tenantKey,
  dto
}: CreateSiteImportJobRequest): Promise<SiteImportJobExEntity> => {
  const { data } = await apiClient._tenant(tenantKey).site_import_jobs.$post({
    body: dto
  })
  return data
}
